import * as React from 'react'
import Masthead from '@ta-interaktiv/react-masthead'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import { displayTypes, ShareButtons } from '@ta-interaktiv/react-share-buttons'
import { PolymorphicCopyrightNotice } from '@ta-interaktiv/react-copyright-notice'
import { TimestampFormatter } from '@ta-interaktiv/react-publication-info'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import 'styles/App.css'
import { hot } from 'react-hot-loader'
// import Parliament from './Parliament'
import HemicycleFocus from './HemicycleFocus'
import ScrollBloc from './ScrollBloc'

class AppComponent extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      genderGraph: {
        values: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14],
        valueIndex: 0
      }
    }
  }

  render () {
    return (
      <div className='index'>
        <Masthead
          enablePaywall={false}
          defaultLanguage='fr'
          mediaName='tdg'
          homepage='//www.tdg.ch'
          articleId='19413979'
          fullMediaName='Tribune de Genève'
          hashtags={['tdgch']}
        />

        <header className='ui vertical fitted segment'>
          <div className='ui container' style={{ textAlign: 'center' }}>
            <h1 className='ui header' style={{ marginBottom: 0 }}>
              Voici comment la Suisse utilise son territoire
            </h1>
            <h2 className='ui header' style={{ marginTop: 0 }} />
            <p className='ta author'>Duc-Quang Nguyen, Mathieu Rudaz</p>
          </div>
        </header>

        <div className='ui text container'>
          <p>
            La sauvegarde du paysage sera le thème majeur de 2019. Outre l’initiative sur
            le mitage le 10 février, pas moins de quatre autres textes ont été ou seront
            lancés cette année pour viser eux aussi la protection des paysages de ce pays. Sur
            ce thème, impossible d’échapper à l’avalanche des statistiques.
          </p>
          <p>
            Saviez-vous que les terrains de golf occupent davantage de place que les parcs
            publics? Que les vignes sont plus répandues que les bâtiments publics? Voici un
            décryptage en cartes de l’utilisation du sol suisse.
          </p>
        </div>

        <div className='ui container animated-scroll-section'>
          <div className='scroll-figure'>
            <HemicycleFocus
              title='Alter und Geschlecht'
              subtitle='Morbi in odio a arcu vehicula vestibulum vitae'
              num={this.state.genderGraph.valueIndex}
              height={13}
              deputiesCount={
                this.state.genderGraph.values[this.state.genderGraph.valueIndex]
              }
              swissCount={0}
            />
          </div>
          <div className='scroll-caption'>
            <ScrollBloc
              callback={d => {
                let p = { ...this.state.genderGraph }
                p.valueIndex = p.valueIndex + d
                this.setState({ genderGraph: p })
              }}
            >
              <div className='animated-scroll-inner-section'>
                <div className='animated-scroll-textbloc'>
                  <p>
                    Chacun de ces carrés représente 4&nbsp;km<sup>2</sup> dédiés majoritairement
                    à <b>l’habitat et à l’infrastructure</b>, comme les constructions et les routes.
                  </p>
                  <p>
                    Au total, ces surfaces représentent moins de 8% du territoire helvétique. En
                    comparaison avec ses voisins, la Suisse demeure loin de la France&nbsp;(12%), de
                    l’Italie&nbsp;(13%) ou de la moyenne de l’Union européenne&nbsp;(11%).
                  </p>
                </div>
              </div>
            </ScrollBloc>

            <ScrollBloc
              callback={d => {
                let p = { ...this.state.genderGraph }
                p.valueIndex = p.valueIndex + d
                this.setState({ genderGraph: p })
              }}
            >
              <div className='animated-scroll-inner-section'>
                <div className='animated-scroll-textbloc'>
                  <p>
                    Si l’on plaçait l’intégralité des surfaces vouées à l’habitat et aux
                    infrastructures du pays côte à côte, on recouvrirait une zone allant
                    de Genève à Vevey et s’étendant jusqu’à La Chaux-de-Fonds.
                  </p>
                </div>
              </div>
            </ScrollBloc>

            <ScrollBloc
              callback={d => {
                let p = { ...this.state.genderGraph }
                p.valueIndex = p.valueIndex + d
                this.setState({ genderGraph: p })
              }}
            >
              <div className='animated-scroll-inner-section'>
                <div className='animated-scroll-textbloc'>
                  <p>
                    Les aires d’habitat et d’infrastructure ne sont pas constituées uniquement de
                    béton. Elles comprennent par exemple les terrains de golf, les parcs publics
                    et les terrains jouxtant les habitations. Ces derniers représentent plus de
                    trois fois la surface occupée par les logements.
                  </p>
                </div>
              </div>
            </ScrollBloc>

            <ScrollBloc
              callback={d => {
                let p = { ...this.state.genderGraph }
                p.valueIndex = p.valueIndex + d
                this.setState({ genderGraph: p })
              }}
            >
              <div className='animated-scroll-inner-section'>
                <div className='animated-scroll-textbloc'>
                  <p>
                    Les <b>surfaces agricoles</b> couvrent plus d’un tiers du territoire (35%).
                  </p>
                </div>
              </div>
            </ScrollBloc>

            <ScrollBloc
              callback={d => {
                let p = { ...this.state.genderGraph }
                p.valueIndex = p.valueIndex + d
                this.setState({ genderGraph: p })
              }}
            >
              <div className='animated-scroll-inner-section'>
                <div className='animated-scroll-textbloc'>
                  <p>
                    Plus de 70% des terres agricoles servent à nourrir le bétail (alpages, pâturages et prairies).
                  </p>
                </div>
              </div>
            </ScrollBloc>

            <ScrollBloc
              callback={d => {
                let p = { ...this.state.genderGraph }
                p.valueIndex = p.valueIndex + d
                this.setState({ genderGraph: p })
              }}
            >
              <div className='animated-scroll-inner-section'>
                <div className='animated-scroll-textbloc'>
                  <p>
                    Les <b>surfaces boisées</b> couvrent près d’un tiers du territoire&nbsp;(31%). Il
                    n’y a pas que le béton qui avance, les forêts aussi ne cessent de s’étendre. C'est
                    surtout dans les Alpes, au-dessus de 1500 mètres, que les arbres gagnent du
                    terrain. Ils se répandent dans les pâturages inexploités autrefois dévolus à
                    l'agriculture.
                  </p>
                </div>
              </div>
            </ScrollBloc>

            <ScrollBloc
              callback={d => {
                let p = { ...this.state.genderGraph }
                p.valueIndex = p.valueIndex + d
                this.setState({ genderGraph: p })
              }}
            >
              <div className='animated-scroll-inner-section'>
                <div className='animated-scroll-textbloc'>
                  <p>Les forêts constituent les 90% des surfaces boisées.</p>
                </div>
              </div>
            </ScrollBloc>

            <ScrollBloc
              callback={d => {
                let p = { ...this.state.genderGraph }
                p.valueIndex = p.valueIndex + d
                this.setState({ genderGraph: p })
              }}
            >
              <div className='animated-scroll-inner-section'>
                <div className='animated-scroll-textbloc'>
                  <p>
                    Les <b>surfaces improductives</b> comme les rochers, les éboulis, les
                    lacs et les glaciers, représentent un peu plus d’un quart du territoire. Une
                    part importante en comparaison avec d’autres pays, en cause les Alpes qui
                    occupent 60% de la Suisse.
                  </p>
                </div>
              </div>
            </ScrollBloc>

            <ScrollBloc
              callback={d => {
                let p = { ...this.state.genderGraph }
                p.valueIndex = p.valueIndex + d
                this.setState({ genderGraph: p })
              }}
            >
              <div className='animated-scroll-inner-section'>
                <div className='animated-scroll-textbloc'>
                  <p>
                    Les rochers et éboulis constituent la majeure partie des surfaces improductives, avec
                    près de 45%.
                  </p>
                </div>
              </div>
            </ScrollBloc>

            <ScrollBloc
              callback={d => {
                let p = { ...this.state.genderGraph }
                p.valueIndex = p.valueIndex + d
                this.setState({ genderGraph: p })
              }}
            >
              <div className='animated-scroll-inner-section'>
                <div className='animated-scroll-textbloc'>
                  <p>
                    Cette carte réunit tous les différents types d’utilisation et de couverture du sol, elle
                    résume comment <b>la Suisse</b> utilise son territoire.
                  </p>
                  <p>
                    Les terrains de golf couvrent par exemple 35&nbsp;km<sup>2</sup>, soit davantage que
                    la totalité des parcs publics (34&nbsp;km<sup>2</sup>) ou des décharges (31&nbsp;km<sup>2</sup>).
                  </p>
                </div>
              </div>
            </ScrollBloc>

            <ScrollBloc
              callback={d => {
                let p = { ...this.state.genderGraph }
                p.valueIndex = p.valueIndex + d
                this.setState({ genderGraph: p })
              }}
            >
              <div className='animated-scroll-inner-section'>
                <div className='animated-scroll-textbloc'>
                  <p>
                    Les vignobles (156&nbsp;km<sup>2</sup>) tapissent plus de
                    terres que l’intégralité des bâtiments publics et leurs
                    terrains attenants (112&nbsp;km<sup>2</sup>) ou que les
                    aires ferroviaires (94&nbsp;km<sup>2</sup>).
                  </p>
                </div>
              </div>
            </ScrollBloc>

            <ScrollBloc
              callback={d => {
                let p = { ...this.state.genderGraph }
                p.valueIndex = p.valueIndex + d
                this.setState({ genderGraph: p })
              }}
            >
              <div className='animated-scroll-inner-section'>
                <div className='animated-scroll-textbloc'>
                  <p>
                    Voici le <b>canton de Vaud</b>, un territoire largement agricole. Les terres
                    arables représentent 22% de son territoire, soit 12 points de plus qu’au niveau
                    national (10%).
                  </p>
                </div>
              </div>
            </ScrollBloc>

            <ScrollBloc
              callback={d => {
                let p = { ...this.state.genderGraph }
                p.valueIndex = p.valueIndex + d
                this.setState({ genderGraph: p })
              }}
            >
              <div className='animated-scroll-inner-section'>
                <div className='animated-scroll-textbloc'>
                  <p>
                    Une large proportion du <b>canton de Genève</b> est allouée aux aires de
                    bâtiments (19%, comprenant les habitations et autres bâtiments), soit 15
                    points de plus qu’en Suisse (4%). À l’inverse, les forêts représentent
                    moins de 11% de ses terres (27% au niveau national).
                  </p>
                </div>
              </div>
            </ScrollBloc>
          </div>
        </div>

        <div className='ui text container'>
          <p>
            Chaque canton présente un profil de l’utilisation du sol distinct. Ce graphique
            illustre la grande variété des 26 cantons, il présente la proportion des quatre
            principaux types de territoire.
          </p>
        </div>

        <figure className='ui container illustration-wrapper tablet or lower hidden'>
          <img
            alt="Les quatre types d'utilisation du sol de chaque canton"
            src={require('./images/cantons_treemap_desktop.svg')}
          />
        </figure>

        <figure className='ui container illustration-wrapper widescreen hidden large screen hidden computer hidden'>
          <img
            alt="Les quatre types d'utilisation du sol de chaque canton"
            src={require('./images/cantons_treemap_mobile.svg')}
          />
        </figure>

        <div
          style={{
            marginTop: '2em',
            backgroundColor: '#f8f9fa',
            padding: '2em 0',
            borderTop: '1px solid rgba(0, 0, 0, 0.02)'
          }}
        >
          <div className='ui text container'>
            <h2>Méthode et données</h2>
            <p>
              À l’aide de photographies aériennes et des registres du
              territoire, l’Office fédéral de la statistique classifie chaque
              hectare (100x100m) du territoire helvétique.
            </p>

            <p>
              Nous nous sommes basés sur ces{' '}
              <a
                className='colorized'
                href='https://www.bfs.admin.ch/bfs/fr/home/statistiques/espace-environnement/utilisation-couverture-sol.html'
                target='_blank'
              >
                statistiques de la superficie
              </a>{' '}
              pour réaliser ces cartes, en utilisant les données les plus
              récentes. Les statistiques utilisées sont de 2018, sauf pour les
              cantons des Grisons, du Tessin et de Glaris où seules les données de
              2009 sont actuellement disponibles.
            </p>
          </div>
        </div>

        <footer className='ui vertical segment'>
          <div className='ui container'>
            <div className='ui two column divided stackable inverted grid'>
              <div className='stretched aligned row'>
                <div className='column'>
                  <table className='ui definition very basic small inverted infographic table'>
                    <tbody>
                      <tr>
                        <td>Texte</td>
                        <td>Duc-Quang Nguyen</td>
                      </tr>
                      <tr>
                        <td>Visuels et programmation</td>
                        <td>Mathieu Rudaz</td>
                      </tr>
                      <tr>
                        <td>Relecture et correction</td>
                        <td>Julien Wicky, Jean-Michel Bugnon</td>
                      </tr>
                      <tr>
                        <td>Adaptation</td>
                        <td>
                          Bloomberg -{' '}
                          <a target='_blank' href='https://www.bloomberg.com/graphics/2018-us-land-use/'>Here's how America uses its land</a>
                        </td>
                      </tr>
                      <tr>
                        <td>Données</td>
                        <td>Office fédéral de la statistique (OFS)</td>
                      </tr>
                      <tr>
                        <td>Publication</td>
                        <td>
                          <TimestampFormatter timestamp={1525222800 - 3600} />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='column'>
                  <FeedbackMessage
                    question='Vous voulez communiquer un renseignement ou vous avez repéré une erreur?'
                    call='Envoyez-nous un '
                    mail='message'
                    mailTo='tg.web@sr.tdg.ch'
                  />

                  <div className='ui fluid share container'>
                    <ShareButtons
                      articleId='19413979'
                      hashtags={['tdgch']}
                      displayType={displayTypes.VERTICAL_BUTTONS}
                    />
                  </div>
                </div>
                <div className='column'>
                  <div className='ui fluid copyright container'>
                    <PolymorphicCopyrightNotice />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    )
  }
}

export default hot(module)(AppComponent)



// WEBPACK FOOTER //
// ./src/components/main/index.js